import { createSlice } from '@reduxjs/toolkit';
import { makePropertyReducer } from 'store/utils';
import { AuthState } from './types';

const getPropertyReducer = makePropertyReducer<AuthState>();

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    accountId: '',
    isAuthenticated: false,
    isSessionInvalid: false,
    account: undefined,
    userAccountProfile: undefined,
  } as AuthState,
  reducers: {
    ...getPropertyReducer('accountId'),
    ...getPropertyReducer('isAuthenticated'),
    ...getPropertyReducer('isSessionInvalid'),
    ...getPropertyReducer('account'),
    ...getPropertyReducer('userAccountProfile'),
  },
});

export const {
  actions: {
    setAccountId,
    setIsAuthenticated,
    setIsSessionInvalid,
    setAccount,
    setUserAccountProfile,
  },
  reducer: authReducer,
} = authSlice;
